<script>
import { required } from '@/utils/propTypes';
import { AccountTypes } from '@/constants';

export default {
  props: {
    signupAs: required(String),
  },
  data: () => ({ AccountTypes }),
  computed: {
    signupFormComponent() {
      return `${this.signupAs}-signup`;
    },
    previewImage() {
      return `https://respondentinc-assets.s3.amazonaws.com/images/${this.signupAs}-preview.png`;
    },
    callToActionText() {
      if (this.signupAs === AccountTypes.researcher)
        return 'Trusted by the world-class research teams';
      return 'Help shape world-class products';
    },
  },
};
</script>

<template>
  <div class="signup-page">
    <v-container>
      <slot />
    </v-container>
    <div class="graphics">
      <v-img
        alt="respondent platform preview"
        :aspect-ratio="1.5925058548"
        class="ml-5 mr-5 mt-6"
        :src="previewImage"
      />
      <v-btn
        v-if="signupAs === AccountTypes.participant"
        outlined
        :min-width="500"
        color="primary"
        class="black-border mt-3"
        href="/respondents/v2/projects/browse"
      >
        Preview Projects
      </v-btn>
      <v-img
        alt="brand logos of some of our customers"
        :aspect-ratio="5.18918918919"
        class="logos"
        :class="signupAs === AccountTypes.participant ? 'mt-5' : 'mt-76px'"
        src="https://respondentinc-images.s3.amazonaws.com/assets/our-customers.svg"
      />
      <p class="mt-6">
        {{ callToActionText }}
      </p>
    </div>
  </div>
</template>

<style scoped lang="scss">
.signup-page {
  --graphic-width: calc(100vw - 386px);
  display: flex;
  flex-direction: row;
  margin-top: 10px;
}

.black-border {
  border-color: var(--v-black-base);
}

.container {
  width: auto;
}

.graphics {
  width: var(--graphic-width);
  max-width: 50vw;
  text-align: center;

  .mt-76px {
    margin-top: 76px;
  }

  .logos {
    margin-right: 10%;
    margin-left: 10%;
  }

  &::after {
    content: '';
    display: block;
    position: fixed;
    top: 0;
    right: 0;
    z-index: -1;
    width: var(--graphic-width);
    max-width: 50vw;
    height: 100vh;
    background: #f9fafc;
  }
}

@media screen and (max-width: 1000px) {
  .graphics {
    display: none;
  }
}
</style>
